document.addEventListener('DOMContentLoaded', () => {
  createAnimatedLayer('after1');
  createAnimatedLayer('after2');
  createAnimatedLayer('after3');
});

function createAnimatedLayer(className) {
  const div = document.createElement('div');
  div.classList.add(className);
  document.body.appendChild(div);
}
